// extracted by mini-css-extract-plugin
export default {"hasBorder":"outline_hasBorder","hasHover":"outline_hasHover"};